module.exports = __webpack_public_path__ + "static/burak-97c70b7bf75b95159b35c37e9e5e6e91.png";